import text from './text';
import link from './link';
import plate from './plate';

export default {
  text,
  link,
  plate,
};
